import './Footer.css'

export function Footer () {
  return (
    <footer className='main-footer'>
      <div className='container footer-container'>
        <div className='copyright'>
          <p>Copyright © 2025 Fern and Fable</p>
        </div>
        <div className='social-links'>
          <a
            href='https://www.facebook.com/profile.php?id=61573216648997'
            target='_blank'
            aria-label='Visit our Facebook page'
            rel='noreferrer'
          >
            <i className='fab fa-facebook'></i>
          </a>
          <a
            href='https://www.instagram.com/fernandfablepicnics'
            target='_blank'
            aria-label='Visit our Instagram page'
            rel='noreferrer'
          >
            <i className='fab fa-instagram'></i>
          </a>
        </div>
      </div>
    </footer>
  )
}
